<!-- <h1 mat-dialog-title>Hi {{data.name}}</h1>
<div mat-dialog-content>
  <p>What's your favorite animal?</p>
  <mat-form-field>
    <mat-label>Favorite Animal</mat-label>
    <input matInput [(ngModel)]="data.animal">
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">No Thanks</button>
  <button mat-button [mat-dialog-close]="data.animal" cdkFocusInitial>Ok</button>
</div> -->


<mat-dialog-content class="content" style="position: relative; top: -15px;">
    <!-- <button (click)='show()'> test</button> -->
    <div class="sch-com">
        <!-- Feeding -->
        <div class="sch-item" *ngIf="data.for == 'feed'">
            <P>Feeding</P>
            <div class="card-header">
                <mat-form-field style="width: 100%;">
                    <mat-label>Select Period</mat-label>
                    <mat-select [value]="data.feedData?.feedSchedule?.id" (selectionChange)="resultSchedule($event)">
                        <mat-option *ngFor="let time of data.feedSch" [value]="time.id">
                            {{time.time}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="card-header">

                <mat-form-field style="width: 100%;">
                    <mat-label>Select Amount</mat-label>
                    <mat-select [value]="data.feedData?.feedAmount?.id" (selectionChange)="resultAmount($event)">
                        <mat-option *ngFor="let amt of data.feedAmount" [value]="amt.id">
                            {{amt.amount}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="card-header">

                <mat-form-field style="width: 100%;">
                    <mat-label>Select Unit</mat-label>
                    <mat-select [value]="data.feedData?.feedUnit?.id" (selectionChange)="resultUnit($event)">
                        <mat-option *ngFor="let unit of data.feedUnit" [value]="unit.id">
                            {{unit.unit}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="card-header">

                <mat-form-field class="example-full-width" style="width:300px;">
                    <mat-label>Description</mat-label>
                    <textarea matInput [(ngModel)]="data.feedData.description"></textarea>
                </mat-form-field>
            </div>
            <div style="display: flex; justify-content: end;">
                <button mat-button style="background-color:#df0000; color: #eee;margin-right: 5px; margin-bottom: 10px;"
                    (click)="onNoClick()">Cancel</button>
                <button mat-button style="color: #eee; margin-bottom: 10px; padding: 0px 25px;" (click)='onYesClick()'
                    [disabled]="formCheck()" [ngClass]="formCheck()? 'dark':'white'">{{data.mode}}</button>
            </div>
        </div>

        <!-- Medication -->
        <div class="sch-item" *ngIf="data.for == 'med'">
            <P>Medication</P>
            <div class="card-header">
                <mat-form-field style="width: 100%">
                    <mat-label>Select Period</mat-label>
                    <mat-select [value]="data.medData?.medicationSchedule.id" (selectionChange)="resultSchedule($event)">
                        <mat-option *ngFor="let time of data.feedSch" [value]="time.id">
                            {{time.time}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="card-header">

                <mat-form-field style="width: 100%">
                    <mat-label>Select Amount</mat-label>
                    <mat-select [value]="data.medData?.medicationAmount?.id" (selectionChange)="resultAmount($event)">
                        <mat-option *ngFor="let amt of data.feedAmount" [value]="amt.id">
                            {{amt.amount}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="card-header">

                <mat-form-field style="width: 100%">
                    <mat-label>Select Unit</mat-label>
                    <mat-select [value]="data.medData?.medicationUnit?.id" (selectionChange)="resultUnit($event)">
                        <mat-option *ngFor="let unit of data.feedUnit" [value]="unit.id">
                            {{unit.unit}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <!-- Medication -->
            <div class="card-header">

                <mat-form-field style="width: 100%" *ngIf="data.for == 'med'">
                    <mat-label>Select Type</mat-label>
                    <mat-select [value]="data.medData?.medicationType?.id" (selectionChange)="resultType($event)">
                        <mat-option *ngFor="let type of data.Type" [value]="type.id">
                            {{type.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="card-header">

                <mat-form-field class="example-full-width" style="width: 300px">
                    <mat-label>Description</mat-label>
                    <textarea matInput [(ngModel)]="data.medData.description"></textarea>
                </mat-form-field>
            </div>

            <div style="display: flex; justify-content: end;">
                <button mat-button style="background-color:#df0000; color: #eee;margin-right: 5px; margin-bottom: 10px;"
                    (click)="onNoClick()">Cancel</button>
                <button mat-button style=" color: #eee; margin-bottom: 10px; padding: 0px 25px;" (click)='onYesClick()'
                    [disabled]="formCheck()" [ngClass]="formCheck()? 'dark':'white'">{{data.mode}}</button>
            </div>
        </div>

    </div>

</mat-dialog-content>